import { Div } from '@kizi/core-components';
import React, { useEffect, useState } from 'react';
import { CustomAccordion } from '../ModalWithAccordion';
import { isMobileXs } from '../../../utils/global';

export const FeaturesTab = ({ data }) => {
  const [contentItems, setContentItems] = useState([]);
  const [outdoorItems, setOutdoorItems] = useState([]);
  const [glassItems, setGlassItems] = useState([]);
  const [homeItems, setHomeItems] = useState([]);

  useEffect(() => {
    if (data) {
      const contentItems = data['CONTENT']
        ?.map(({ name, details }, i) => ({
          key: i,
          label: name,
          content: <Div mt={2}>{details}</Div>,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));

      const outdoorItems = data['OUTDOOR']
        ?.map(({ name, details }, i) => {
          return {
            key: i,
            label: name,
            content: <Div mt={2}>{details}</Div>,
          };
        })
        .sort((a, b) => a.label.localeCompare(b.label));

      const glassItems = data['GLASS']
        ?.map(({ name, details }, i) => {
          return {
            key: i,
            label: name,
            content: <Div mt={2}>{details}</Div>,
          };
        })
        .sort((a, b) => a.label.localeCompare(b.label));
      const homeItems = data['HOME']
        ?.map(({ name, details }, i) => {
          return {
            key: i,
            label: name,
            content: <Div mt={2}>{details}</Div>,
          };
        })
        .sort((a, b) => a.label.localeCompare(b.label));

      setContentItems(contentItems);
      setOutdoorItems(outdoorItems);
      setGlassItems(glassItems);
      setHomeItems(homeItems);
    }
  }, [data]);

  return (
    <>
      {contentItems?.length > 0 && (
        <Div variant={isMobileXs() ? 'extraServiceAccordionSubHeader' : ''}>
          <h2>Inboedel</h2>
          <CustomAccordion items={contentItems} size="small" />
        </Div>
      )}
      {outdoorItems?.length > 0 && (
        <Div variant={isMobileXs() ? 'extraServiceAccordionSubHeader' : ''}>
          <h2>Buitenshuis</h2>
          <CustomAccordion items={outdoorItems} size="small" />
        </Div>
      )}
      {homeItems?.length > 0 && (
        <Div variant={isMobileXs() ? 'extraServiceAccordionSubHeader' : ''}>
          <h2>Glas</h2>
          <CustomAccordion items={homeItems} size="small" />
        </Div>
      )}
      {glassItems?.length > 0 && (
        <Div variant={isMobileXs() ? 'extraServiceAccordionSubHeader' : ''}>
          <h2>Glas</h2>
          <CustomAccordion items={glassItems} size="small" />
        </Div>
      )}
    </>
  );
};
